exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".basic-container .time {\n  font-size: 13px;\n  color: #999;\n}\n", ""]);

// exports
